module.exports = __webpack_public_path__ + "static/img/8.02a9354.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productcenter/8.png
// module id = DGV1
// module chunks = 1